<template>
  <div class="introduce">
    <img  src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/banner.jpg" class="competition-img" @click="handleClickToSign(4)">

    <div class="intro-content">
      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/one.svg">
      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 244(1).svg">

      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 244(7).svg">
    </div>
    <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 244.svg"  class="competition-img">
    <div class="intro-content">
      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 244(2).svg">
      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 244(3).svg">

      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 244(4).svg">
      <div class="sign-up-but2" >报名入口</div>
      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/png/Slice 241(1).png" width="200">
      <div class="sign-up-but3"  @click="handleClickToSign(4)">立即报名</div>
      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 243.svg">

      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 244(5).svg">
      <img src="https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/vote-svg/Slice 244(6).svg">
    </div>
  </div>
</template>

<script>
import {activityDetail, getActivityPlateList, getActivityCategoryList, getWorksList,getRankingList} from "@/api/Vote.js";
import {bannerAreaList} from "@/api/CourseCenter";
import {mapGetters} from "vuex";

const DEFAULT_ACTIVITY_ID = 5;

export default {
  name: "workCompetition",
  components: {},
  data() {
    return {
      activeKey: 0,
      activityId: DEFAULT_ACTIVITY_ID,
      activityObj: {},
      worksList: [],

    };
  },
  computed: mapGetters(["userInfo", "isLogin"]),
  mounted() {

    this.getActivity();
  },
  filters: {
    formatDateYYYYMMDD(value) {
      if (!value) return '';
      const date = new Date(value);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    daysRemaining(targetTime) {
      if (!targetTime) return 'N/A';
      const targetDate = new Date(targetTime.replace(' ', 'T'));
      const now = new Date();
      const diffMs = targetDate - now;
      const diffDays = Math.ceil(diffMs / 86400000);

      if (diffDays > 0) return `剩余${diffDays}天`;
      if (diffDays === 0) return '今天截止';
      return '已过期';
    }
  },

  methods: {

    getActivity() {
      const activityId = DEFAULT_ACTIVITY_ID;
      activityDetail(activityId, {isShow: 0, uid: this.userInfo.uid | 0}).then(res => {
        this.activityObj = res.data
        this.categoryList=res.data.categoryVos
        this.activityId=res.data.id
      })
    },

    handleClickToSign() {
      this.$router.push("/ContestApply/" + DEFAULT_ACTIVITY_ID);
    },
    handleClickToWorks(id) {
      this.$router.push("/WorkCompetition/"+id);
    },
  },
};
</script>

<style lang="scss">
.introduce {
  background: #F7F8FA;
  img{
    z-index: -10;
  }
  .competition-img {
    width: 100%;
    height: auto;
  }

  .course-img {
    width: 100%;
    height: auto;
  }
  .intro-content-btu{
    position: relative; /* 设置相对定位，为内部绝对定位元素提供参考 */
    margin-top: -120px;
    margin-bottom: 70px;
    text-align: right;
  }
  .intro-content-btu-btu{
    width: 1300px;
    margin: 0 auto;
    text-align: right;
  }
  .sign-up-btu-img{
    position: relative; /* 设置相对定位，为内部绝对定位元素提供参考 */
    margin-top: -200px;
  }
  .sign-up-btu {
    position: relative; /* 设置相对定位，为内部绝对定位元素提供参考 */
    margin-top: -224px;
    margin-left: -170px;
    font-size: 24px;
    font-weight: bold;
    height: 60px;
    color: #ffffff;
    padding: 10px;
    text-align: center;
  }

  .sign-up-but2 {
    position: relative; /* 设置相对定位，为内部绝对定位元素提供参考 */
    margin-bottom: -25px;
    height: 30px;
    font-size: 18px;
    font-weight: bold;
    color: #F5B776;
    text-align: center;
    span{

    }
  }
  .sign-up-but3{
    position: relative; /* 设置相对定位，为内部绝对定位元素提供参考 */
    margin-top: -38px;
    margin-bottom: 1px;
    height: 30px;
    z-index: 10;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
  }

  .intro-content {
    margin: 0px auto;
    width: 1300px;
    text-align: center;

    .title {
      margin-top: 20px;
      width: 1280px;
      color: #615797;
      font-size: 24px;
      line-height: 24px;
      font-weight: 900;
      display: flex;
      justify-content: space-between;


      span {
        margin-right: 0px;
        //color: #FD702E;
        background: linear-gradient(#FD702E, #FD702E);
        -webkit-background-clip: text;
        color: transparent;
        -webkit-text-stroke: 3px white;

        &::after {
          content: "";
          display: inline-flex;
          margin: 4px 0;
          right: 2px;
          width: 40px;
          height: 4px;
          bottom: 0px;
          background-color: #386DAE;
        }
      }

    }

    .content{
      padding: 20px 0 20px 0;
      color: #615599;
      font-size: 16px;
      letter-spacing: 3px;
      font-weight: 900;
      line-height: 26px;
    }


    .box-wrapper {
      display: flex;
      justify-content: left;
      flex-wrap: wrap;
      margin-right: -20px;
      padding: 0;

      .no-show-msg {
        margin: 10px auto;
        font-size: 18px;
      }
    }

    .box {
      border-radius: 10px;
      margin: 0 20px 26px 0;
      width: 305px;
      height: 305px;
      box-shadow: 0px 0px 8px 5px rgb(0 0 0 / 9%);
      cursor: pointer;
      transition: 1s;

      &:hover {
        box-shadow: 0px 2px 8px 8px rgb(0 0 0 / 20%);
        transform: scale(1.02);
      }

      img {
        border-radius: 10px 10px 0 0;
        width: 305px;
        height: 171px;
      }

      .content {
        padding: 0 10px 0 8px;
        text-align: left;

        .topic {
          line-height: 35px;
          font-size: 16px;
          color: #000000;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .teacher {
          line-height: 25px;
          font-size: 14px;
          color: #999999;
        }

        .info {
          padding: 10px 0 0px 0;
          line-height: 14px;
          color: #999999;
          display: flex;
          justify-content: space-between;

          img {
            margin-top: -50px;
            width: 70px;
            height: auto;
          }

          .num {
            color: #E28947;
            font-size: 16px;

            em {
              margin-top: 8px;
              margin-right: 5px;
              font-size: 26px;
            }
          }

          .submit {
            border-radius: 50px;
            padding: 8px 30px;
            background: #E28947;
            color: #ffffff;
            font-size: 16px;
          }

          .course-time {
            background: url("~@/assets/img/course-time.png") no-repeat;
            background-size: 15px 15px;
            text-indent: 20px;
          }
        }
      }
    }


  }

}
</style>
